export enum CONFIG_TYPE {
  CONFIG = "config",
  BRANDING = "branding",
  APP_VERSION = "app_version",
}
